import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocCategoryIsAkAndDocTypeAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentCategory = control.get('documentCategory')!.value;
	const documentType = control.get('documentType')!.value;
	const foreignCustomerId = control.get('foreignCustomerId')!.value;
	const documentTypeArray = ['EGD018', 'EGD030', 'EGD033'];

	return !foreignCustomerId && !!documentType && documentCategory ===  "EGD01"
	            && !documentTypeArray.includes(documentType) ? { checkDocCategoryIsAkAndDocTypeAllowedFlag: true } : null;
};
